import { environment } from './../../../../environments/environment';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router } from '@angular/router';
import { DatalocalService } from '../dataLocal/datalocal.service';

@Injectable({
  providedIn: 'root'
})
export class AutenticacionService {

  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;

  API_MOBILE: string = environment.urlLogin;
  API_CAMPANIA: string = environment.urlCampania;
  authBasic = 'Basic c2VydmljZXM6MC49ajNEMnNzMS53Mjkt';
  headerspe() {
    return this.API_MOBILE.startsWith('http://192')
      ? {}
      :new HttpHeaders().append('Authorization', this.authBasic);
  }  
  pais=environment.PAIS
  headers() {
    return this.API_CAMPANIA.startsWith('http://192')
      ? {}
      :new HttpHeaders().append('Authorization', this.authBasic);
  }
  constructor(
    private httpClient: HttpClient,
    private localS: LocalStorageService,
    private router: Router,
    private DatalocalService: DatalocalService) {
    this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(this.localS.get('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue() {
    return this.currentUserSubject.value;
  }

  async login(usuario) {
    let user = {
      user: usuario.strUsuario,
      pss: 'auth-token'
    }
    //let headers=this.headers();    
    let consulta = null;
    let url = ''
    if(this.pais == 'ES'){
      let headers = this.headers();
      url = `${this.API_CAMPANIA}/loginUsuario`;
      consulta = await this.httpClient.post<any>(url, usuario,{ headers }).toPromise();
    }else if(this.pais == 'PE'){
      let headers = this.headerspe();
      const url = `${this.API_MOBILE}/loginUsuario`;
      consulta = await this.httpClient.post<any>(url, usuario, { headers }).toPromise();
    }
    else{
      url = `${this.API_MOBILE}/loginUsuarioAdmin`;
      consulta = await this.httpClient.post<any>(url, usuario).toPromise();
    }
    if (consulta.length > 0) {
      await this.localS.set('usuario', JSON.stringify(consulta[0]));
      await this.localS.set('currentUser', JSON.stringify(user));
      await this.localS.set('codPerfil',consulta[0].codPerfil);
      await this.localS.set('codUsuario',consulta[0].codUsuario)
      await this.localS.set('codVendedor',consulta[0].codVendedor)
      await this.currentUserSubject.next(user);
      return consulta[0];
    }
  }

  // getPermisos(cod_perfil){
  //   let headers=this.headers();
  //   let params = new HttpParams().append("cod_perfil", cod_perfil)
  //   return this.httpClient.get(`${environment.urlSeguridad}/getMenus`, { params: params,headers})
  // }

  // getPermisosByUser(cod_user){
  //   let params = new HttpParams().append("cod_usuario", cod_user)
  //   return this.httpClient.get(`${environment.urlSeguridad}/getMenusUser`, { params: params})
  // }

  // async getUsuarioId(): Promise<number> {
  //   return (await this.DatalocalService.obtenerItem('AdminImplementos.codUsuario')) as number;
  // }

  // async getNombreUsuario(): Promise<string> {
  //   const usuario = JSON.parse(await this.DatalocalService.obtenerItem('AdminImplementos.usuario'));
  //   return usuario.nombre as string;
  // }
  getCodVendedor(){
    const usuarioStr =  this.DatalocalService.obtenerItemB('AdminImplementos.usuario');
    if (usuarioStr) {
        const usuarioObj = JSON.parse(usuarioStr);
        return usuarioObj.codVendedor as string;
    }
    return '';
  }

  async logout() {
    // remove user from local storage and set current user to null
    this.localS.remove('menu');
    this.localS.remove('usuario');
    this.localS.remove('currentUser');
    this.localS.remove('codPerfil');
    this.localS.remove('codUsuario');
    await this.currentUserSubject.next(null);
    this.router.navigate(['/']);
  }
}
